<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<div class="driver-view-container">
  <div class="driver-view">
    <div class="heading">
      <h3>Driver Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="input-fileds-container category-edit">
      <form action="" [formGroup]="profileForm" class="admin-forms mt-3">
        <div class="row">
          <div class="col-sm-9">
            <!-- Driving License & DOB Verification Box -->
            <div class="dl-verify-box">
              <div class="dl-verify-box-header">
                <div class="dl-verify-title">
                  <img src="../../../assets/img/tick-verify.svg" *ngIf="isDlVerified" class="verify-icon-success" />
                  <span>Driving License Verification</span>
                </div>
                <div class="dl-verify-subtitle" *ngIf="!isDlVerified">
                  Enter DL Number & DOB, then click Verify
                </div>
                <div class="dl-verify-subtitle text-success" *ngIf="isDlVerified">
                  ✓ Verified with National Register (Sarathi)
                </div>
              </div>

              <div class="row dl-verify-row">
                <div class="col-sm-5">
                  <div class="head">Driving License Number<span class="required-asterisk">*</span></div>
                  <div>
                    <mat-form-field>
                      <input
                        toUppercase
                        matInput
                        formControlName="driving_license_number"
                        minlength="10"
                        maxlength="20"
                        placeholder="e.g. GJ04 20120005008"
                        (input)="onDlNumberChange()"
                        [readonly]="isFieldRestricted('driving_license_number')"
                        [class.field-restricted]="isFieldRestricted('driving_license_number')"
                        required
                      />
                      <mat-error
                        *ngIf="(ProfileFormControl['driving_license_number'].touched) && ProfileFormControl['driving_license_number'].errors?.['required']"
                      >
                        License No. is required</mat-error
                      >
                      <mat-error
                        *ngIf="(ProfileFormControl['driving_license_number'].touched) && ProfileFormControl['driving_license_number'].errors?.['pattern']"
                      >
                        Please enter a valid license</mat-error
                      >
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-sm-7">
                  <div class="head">DOB<span class="required-asterisk">*</span></div>
                  <div class="dob-verify-wrapper">
                    <mat-form-field class="dob-input-field">
                      <input
                        (change)="onDateChnage(2)"
                        (click)="!isFieldRestricted('dob') && picker1.open()"
                        matInput
                        [matDatepicker]="picker1"
                        [max]="minDob"
                        formControlName="dob"
                        [readonly]="isFieldRestricted('dob')"
                        [class.field-restricted]="isFieldRestricted('dob')"
                      />
                      <mat-datepicker #picker1 [disabled]="isFieldRestricted('dob')"></mat-datepicker>
                      <mat-error
                        *ngIf='ProfileFormControl["dob"].touched && ProfileFormControl["dob"].errors?.["required"]'
                      >
                        Date of birth is required</mat-error
                      >
                      <mat-error *ngIf="invalidDob"
                        >Please select valid Date of birth</mat-error
                      >
                    </mat-form-field>

                    <div class="verify-btn-container">
                      <button
                        type="button"
                        class="verify-action-btn"
                        (click)="verifyDrivingLicense()"
                        [disabled]="isDlVerifying"
                        *ngIf="!isDlVerified"
                        title="Verify Driving License & DOB with Sarathi"
                      >
                        <span *ngIf="!isDlVerifying">Verify</span>
                        <span *ngIf="isDlVerifying" class="inline-spinner-white"></span>
                      </button>

                      <div *ngIf="isDlVerified" class="d-flex align-items-center gap-1 verify-status-wrapper">
                        <img src="../../../assets/img/tick-verify.svg" style="width: 24px; height: 24px;" title="Verified with Sarathi" />
                        <a
                          *ngIf="!data"
                          (click)="resetDlVerification()"
                          class="change-dl-link"
                          title="Change DL / Re-verify"
                          >Change</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Verified DL Information Card inside the box -->
              <div class="mt-2" *ngIf="isDlVerified && dlVerificationData">
                <div class="dl-verified-card">
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="dl-meta">
                      <span class="meta-label">RTO:</span>
                      <span class="meta-value">{{ dlVerificationData.rto || dlVerificationData.dlobj?.omRtoFullname || 'National Register' }}</span>
                      <span class="meta-divider">•</span>
                      <span class="meta-label">Status:</span>
                      <span class="meta-status text-success">{{ dlVerificationData.status || dlVerificationData.dlobj?.dlStatus || 'Active' }}</span>
                      <span class="meta-divider" *ngIf="dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt">•</span>
                      <span class="meta-label" *ngIf="dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt">Valid Till:</span>
                      <span class="meta-value" *ngIf="dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt">{{ dlVerificationData.validity || dlVerificationData.dlobj?.dlTrValdtoDt }}</span>
                    </div>
                    <div class="dl-badge-wrapper">
                      <span
                        [ngClass]="hasTransportAuthorization ? 'badge-transport-yes' : 'badge-transport-no'"
                        class="transport-badge"
                        [title]="hasTransportAuthorization ? 'Authorized for commercial heavy vehicles' : 'Only non-transport vehicles allowed'"
                      >
                        {{ hasTransportAuthorization ? '✓ Commercial / Transport (TRANS) Authorized' : '⚠ Non-Transport Only (LMV/NT)' }}
                      </span>
                    </div>
                  </div>
                  <div *ngIf="dlVerificationData.classOfVehicle" class="mt-1" style="font-size: 11px; color: #475569;">
                    <strong>Vehicle Classes:</strong> {{ dlVerificationData.classOfVehicle }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2: Driver Name & Mobile Number -->
            <div class="row mtb">
              <div class="col-sm-5">
                <div class="head">Driver Name<span class="required-asterisk">*</span></div>
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="username"
                      style="text-transform: capitalize"
                      [readonly]="isFieldRestricted('username')"
                      [class.field-restricted]="isFieldRestricted('username')"
                      required
                    />
                    <mat-error
                      *ngIf="(ProfileFormControl['username'].touched) && ProfileFormControl['username'].errors?.['required']"
                    >
                      Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['username'].touched) && ProfileFormControl['username'].errors?.['pattern']"
                    >
                      Please enter a valid name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="head">Mobile Number<span class="required-asterisk">*</span></div>
                <div>
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="mobile"
                      minlength="10"
                      maxlength="10"
                      required
                      [readonly]="ismobileVerified"
                      (keypress)="validateNumber($event)"
                    />
                    <mat-error
                      *ngIf="(ProfileFormControl['mobile'].touched) && ProfileFormControl['mobile'].errors?.['required']"
                    >
                      Mobile is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['mobile'].touched) && ProfileFormControl['mobile'].errors?.['pattern']"
                    >
                      Please enter a valid mobile</mat-error
                    >
                    <div class="otp-field" *ngIf="mobileVerified === 0">
                      <img src="../../../assets/img/error.svg" />
                      <a
                        class="otp"
                        (click)="mobileVerification()"
                        style="color: brown"
                        >Send OTP</a
                      >
                    </div>
                    <div class="otp-field" *ngIf="mobileVerified > 0">
                      <img src="../../../assets/img/tick-verify.svg" />
                    </div>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Row 3: Email & Emergency Number -->
            <div class="row mtb">
              <div class="col-sm-5">
                <div class="head">Email</div>
                <div>
                  <mat-form-field>
                    <input matInput type="email" formControlName="email" />
                    <mat-error
                      *ngIf="
                        profileForm.get('email')?.touched
                        && profileForm.get('email')?.value
                        && profileForm.get('email')?.hasError('invalidEmail')
                      "
                    >
                      Please enter a valid email address
                    </mat-error>
                    <div class="otp-field" *ngIf="emailVerified === 0"></div>
                    <div class="otp-field" *ngIf="emailVerified > 0">
                      <img src="../../../assets/img/tick-verify.svg" />
                    </div>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="head">Emergency Number</div>
                <div>
                  <mat-form-field>
                    <input 
                      matInput 
                      minlength="10" 
                      maxlength="10" 
                      formControlName="emergency_contact"
                      (keypress)="validateNumber($event)"
                    />
                    <mat-error
                      *ngIf="(ProfileFormControl['emergency_contact'].touched) && ProfileFormControl['emergency_contact'].errors?.['pattern']"
                    >
                      Please enter a valid Mobile Number</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Row 4: Gender & Assigned Truck Number -->
            <div class="row mtb">
              <div class="col-sm-5">
                <div class="head">Gender<span class="required-asterisk">*</span></div>
                <div class="driver-truck">
                  <mat-form-field appearance="fill" class="example-full-width">
                    <mat-select formControlName="gender">
                      <mat-option value="male">Male</mat-option>
                      <mat-option value="female">Female</mat-option>
                      <mat-option value="others">Others</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-7">
                <div class="head">Assigned Truck Number</div>
                <div class="driver-truck assigned-truck-select" *ngIf="truckDropDownDispaly">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="truck_id">
                      <mat-option value="">Select truck</mat-option>
                      <mat-option
                        *ngFor="let item of truckList"
                        value="{{ item._id }}"
                      >
                        {{ item.truck_number }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  class="assigned-truck-select"
                  *ngIf="!truckDropDownDispaly"
                  (click)="TruckAssigneClicked()"
                >
                  <mat-form-field>
                    <input matInput formControlName="truck_name" readonly />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!-- Row 5: Driver Known Language & Status / Reason -->
            <div class="row mtb">
              <div class="col-sm-5">
                <div class="head">Driver Known Language<span class="required-asterisk">*</span></div>
                <div class="driver-truck">
                  <mat-form-field appearance="fill">
                    <mat-select
                      #langSelect
                      dropLocationSearchField
                      formControlName="known_lang"
                      multiple
                    >
                      <mat-option
                        *ngFor="let lang of languageId"
                        [value]="lang.name"
                      >
                        {{ lang.name }}
                      </mat-option>
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <button class="langbtn btn" (click)="onDoneClick()">
                          Done
                        </button>
                      </div>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-sm-7" *ngIf="status">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="head">Status</div>
                    <div class="driver-truck">
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="driver_status">
                          <mat-option disabled value="available">
                            Available
                          </mat-option>
                          <mat-option disabled value="allocated">
                            Allocated
                          </mat-option>
                          <mat-option value="maintanence" (click)="maintance()">
                            Maintanence
                          </mat-option>
                          <mat-option value="rejected" (click)="reject()">
                            Rejected
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="reasons">
                    <div class="head">Reason</div>
                    <div class="driver-truck">
                      <mat-form-field appearance="fill">
                        <input matInput formControlName="driver_remarks" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="right-img">
              <button (click)="uploadImage.click()" [disabled]="imgLoading">
                <img
                  src="{{
                    profileForm.value.profile_image
                      ? profileForm.value.profile_image
                      : '../../../assets/img/defaultDP.png'
                  }}"
                  class="driverImg"
                />
                <div class="image-upload-area mt-3">
                  <span class="image">
                    <p [class.spinner]="imgLoading">Add/Replace Driver Image</p>
                  </span>
                  <input
                    #uploadImage
                    type="file"
                    (change)="onChange($event)"
                    hidden
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      </form>

      <div class="heading">
        <h3>Documents</h3>
      </div>
      <mat-divider></mat-divider>
      <form action="" [formGroup]="documentForm" class="admin-forms mt-3">
        <div class="row">
          <div class="col-md-12">
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">Driving License<span class="required-asterisk">*</span></div>
              </div>
              <div class="col-md-4">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      [matDatepicker]="picker2"
                      [min]="today"
                      placeholder="License Expiry Date"
                      formControlName="driving_license_expiry"
                      (change)="onDateChnage(3)"
                      (click)="!isFieldRestricted('driving_license_expiry') && picker2.open()"
                      [readonly]="isFieldRestricted('driving_license_expiry')"
                      [class.field-restricted]="isFieldRestricted('driving_license_expiry')"
                    />
                    <mat-datepicker #picker2 [disabled]="isFieldRestricted('driving_license_expiry')"></mat-datepicker>
                    <mat-error
                      *ngIf='documentFormControl["driving_license_expiry"].touched && documentFormControl["driving_license_expiry"].errors?.["required"]'
                    >
                      License expiry date is required</mat-error
                    >
                    <mat-error *ngIf="invalidDocLicense"
                      >Please select valid License expiry date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="col-md-4 d-flex align-items-center justify-content-center"
              >
                <div class="">
                  <span *ngIf="licenseImageName"
                    >{{ licenseImageName.substring(0, 5) + "..." }}
                    <img
                      src="../../../assets/img/cross.svg"
                      class="ms-2"
                      alt=""
                      (click)="cancelLicenseImage()"
                    />
                  </span>
                  <span class="image ms-3" (click)="uploadLicenseImage.click()"
                    >Upload</span
                  >
                  <div [class.spinner]="drivingLicenceLoading"></div>

                  <div *ngIf="!licenseImageName && DrivingLicence">
                    {{
                      DrivingLicence.length > 10
                        ? DrivingLicence.slice(0, 10)
                        : DrivingLicence
                    }}
                    <span
                      *ngIf="DrivingLicence.length > 10"
                      [title]="DrivingLicence"
                      >...</span
                    >
                  </div>
                  <input
                    #uploadLicenseImage
                    type="file"
                    (click)="uploadLicenseImage.value = ''"
                    (change)="onChangeLicense($event)"
                    hidden
                  />
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">Insurance</div>
              </div>
              <div class="col-md-4">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      [matDatepicker]="picker3"
                      [min]="today"
                      placeholder="Insurance Expiry Date"
                      formControlName="insurance_expiry"
                      (change)="onDateChnage(3)"
                      (click)="picker3.open()"
                    />
                    <!-- <mat-datepicker-toggle
                      matSuffix
                      [for]="picker3"
                    ></mat-datepicker-toggle> -->
                    <mat-datepicker #picker3></mat-datepicker>
                    <!-- <mat-error
                      *ngIf='documentFormControl["insurance_expiry"].touched && documentFormControl["insurance_expiry"].errors?.["required"]'
                    >
                      Insurance expiry date is required</mat-error
                    > -->
                    <mat-error *ngIf="invalidInsuranceDate"
                      >Please select valid Insurance expiry date
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="col-md-4 d-flex align-items-center justify-content-center"
              >
                <div class="">
                  <span *ngIf="insuranceImageName"
                    >{{ insuranceImageName.substring(0, 5) + "..." }}
                    <img
                      src="../../../assets/img/cross.svg"
                      class="ms-2"
                      alt=""
                      (click)="cancelInsuranceImage()"
                    />
                  </span>
                  <span
                    class="image ms-3"
                    (click)="uploadInsuranceImage.click()"
                    >Upload</span
                  >
                  <div [class.spinner]="insuranceLoading"></div>

                  <div *ngIf="!insuranceImageName && insuranceLicence">
                    {{
                      insuranceLicence.length > 10
                        ? insuranceLicence.slice(0, 10)
                        : insuranceLicence
                    }}
                    <span
                      *ngIf="insuranceLicence.length > 10"
                      [title]="insuranceLicence"
                      >...</span
                    >
                  </div>
                  <input
                    #uploadInsuranceImage
                    type="file"
                    (click)="uploadInsuranceImage.value = ''"
                    (change)="onChangeLicense($event)"
                    hidden
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      
      <div class="heading"><h3>Contact Details</h3></div>
      <mat-divider></mat-divider>
      <form action="" [formGroup]="contactForm">
        <div class="row">
          <div class="col-md-9">
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Name</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="name"
                      style="text-transform: capitalize"
                      [readonly]="isFieldRestricted('contact_name')"
                      [class.field-restricted]="isFieldRestricted('contact_name')"
                    />
                    <!-- <mat-error
                      *ngIf="(contactFormControl['name'].touched) && contactFormControl['name'].errors?.['required']"
                    >
                      Name is required</mat-error
                    > -->
                    <mat-error
                      *ngIf="(contactFormControl['name'].touched) && contactFormControl['name'].errors?.['pattern']"
                    >
                      Please enter a valid name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Contact Number</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      (keypress)="validateNumber($event)"
                      matInput
                      formControlName="mobile"
                      minlength="10"
                      maxlength="10"
                    />
                    <!-- <mat-error
                      *ngIf="(contactFormControl['mobile'].touched) && contactFormControl['mobile'].errors?.['required']"
                    >
                      Contact number is required</mat-error
                    > -->
                    <mat-error
                      *ngIf="(contactFormControl['mobile'].touched) && contactFormControl['mobile'].errors?.['pattern']"
                    >
                      Please enter a valid contact number</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Email</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput type="email" formControlName="email" />
                    <mat-error
                      *ngIf="
                        contactForm.get('email')?.touched
                        && contactForm.get('email')?.value
                        && contactForm.get('email')?.hasError('invalidEmail')
                      "
                    >
                      Please enter a valid email address
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Address Line</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="address_line" [readonly]="isFieldRestricted('address_line')" [class.field-restricted]="isFieldRestricted('address_line')"/>
                    <!-- <mat-error
                      *ngIf="(contactFormControl['address_line'].touched) && contactFormControl['address_line'].errors?.['required']"
                    >
                      Address is required</mat-error
                    > -->
                    <mat-error
                      *ngIf="(contactFormControl['address_line'].touched) && contactFormControl['address_line'].errors?.['pattern']"
                    >
                      Please enter a valid address</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Area</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="area"/>
                    <!-- <mat-error
                      *ngIf="(contactFormControl['area'].touched) && contactFormControl['area'].errors?.['required']"
                    >
                      Area is required</mat-error
                    > -->
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">City</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="city"/>
                    <!-- <mat-error>City is required</mat-error> -->
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">State</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="state"/>
                    <!-- <mat-error>State is required</mat-error> -->
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Pincode</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="pincode"
                      minlength="6"
                      maxlength="6"
                      (keypress)="validateNumber($event)"
                    />
                    <!-- <mat-error
                      *ngIf="(contactFormControl['pincode'].touched) && contactFormControl['pincode'].errors?.['required']"
                    >
                      Pincode is required</mat-error
                    > -->
                    <mat-error
                      *ngIf="(contactFormControl['pincode'].touched) && contactFormControl['pincode'].errors?.['pattern']"
                    >
                      Please enter a valid pincode</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="fixed-btn">
        <button
          *ngIf="!data"
          [class.spinner]="loading"
          [disabled]="loading"
          (click)="onSave()"
        >
          Save
        </button>
        <button
          *ngIf="data"
          [class.spinner]="loading"
          [disabled]="loading"
          (click)="onEditSave()"
        >
          Update
        </button>
      </div>
    </div>
  </div>
</div>
